module.exports = __webpack_public_path__ + "static/img/hub-background.cffb606.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hub/hub-background.png
// module id = eGBb
// module chunks = 0